import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateCity = createAsyncThunk('updateCity', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'city',
            data: {
                "city_id": data?.values?.id,
                "country_id": data?.values?.country,
                "state_id": data?.values?.state,
                "city": data?.values?.city,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

